import * as SEARCH_FILTER_SERVICE from '@/drc/services/drc-request-service';
import {EventSearch} from "@/common/configurations/event-bus.js";
import * as SERVICES from "@/drc/services/drc-request-service";
import store from "@/common/store";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

export const searchFilterMixin = {
    data() {
        return {
            selectedLatest: true,
            selectedMostVisited: false,
            sortFields: {
                views: 'views',
                publishDate: 'management_firstDatePublish'
            },
            sort: {
                by: 'management_firstDatePublish',
                order: 'DESC'
            },
            sortOrders: {
                descending: "DESC"
            },
            page: 0,
            perPage: 27,
            text: '',
            isLoadingNextPage: false,
            mainFilterActions: {
                removeMainFilterParam: (filter) => {
                    return this.removeFilterFromExistingParameter(filter)
                },
                createMainFilterParam: (filter) => {
                    return [filter.id]
                },
                addMainFilterParam: (filter) => {
                    const options = this.getParameterData(filter);
                    this.addFilterToExistingParameter(options, filter);
                    return options;
                }
            },
            subFiltersActions: {
                removeSubFilterParam: (subOptionType, subFilter) => {
                    return this.removeSubFilterFromExistingParameter(subOptionType, subFilter.id)
                },
                createSubFilterParam: (subOptionType, subFilter) => {
                    return [subFilter.id]
                },
                addSubFilterParam: (subOptionType, subFilter) => {
                    const options = this.getSubOptionParameterData(subOptionType);
                    this.addSubFilterToExistingParameter(options, subFilter);
                    return options;
                }
            }
        }
    },
    computed: {
        isLoading() {
            return this.$store.getters.getDoShowLoading;
        }
    },
    methods: {
        getTranslatedName(section) {

            return section.translations !== undefined
                ? section.translations.find(translation => translation.language.name === this.$i18n.locale).name
                : section.name;
        },
        doSearch(event, isScroll) {
            if (event) {
                event.preventDefault();
            }

            this.$store.dispatch('showLoading');
            const params = this.getRequestParams();

						Promise.all([
							SERVICES.searchPageProjects(params)
								.then((response) => {
									if (isScroll) {
										store.dispatch('addUserSavedProjectsOnScroll', response);
									} else {
										store.dispatch('setUserSavedProjects', response);
									}
									this.$store.dispatch('setSearchByFilters', {
										fieldName: 'projects',
										value: response
									});
								})
								.catch((error) => console.error(error)),
							SERVICES.getProjectsCount(params)
								.then((response) => {
									this.$store.dispatch('setSearchByFilters', {fieldName: 'total', value: response.length});
								})
								.catch((error) => console.error(error))
						])
							.finally(() => store.dispatch('hideLoading'))

						// SERVICES.searchPageProjects(params)
						// 	.then((response) => {
						// 		if (isScroll) {
						// 			store.dispatch('addUserSavedProjectsOnScroll', response);
						// 		} else {
						// 			store.dispatch('setUserSavedProjects', response);
						// 		}
						// 		this.$store.dispatch('setSearchByFilters', {
						// 			fieldName: 'projects',
						// 			value: response
						// 		});
						// 		//this.$store.dispatch('setSearchByFilters', {fieldName: 'total', value: response.data.total});
						// 	})
						// 	.catch((error) => console.error(error))
						// 	.finally(() => {
						// 		store.dispatch('hideLoading');
						// 	})

            // SERVICES.fetchUserSavedProjects(params)
            //     .then((response) => {
            //         if (isScroll) {
            //             store.dispatch('addUserSavedProjectsOnScroll', response.data);
            //         } else {
            //             store.dispatch('setUserSavedProjects', response.data);
            //         }
            //         this.$store.dispatch('setSearchByFilters', {
            //             fieldName: 'projects',
            //             value: response.data.projects
            //         });
            //         this.$store.dispatch('setSearchByFilters', {fieldName: 'total', value: response.data.total});
            //     })
            //     .catch((error) => {
            //         console.error(error);
            //     })
            //     .finally(() => {
            //         store.dispatch('hideLoading');
            //     });
        },
        getRequestParams() {
            const isSubFilter = true;
            const params = {
                user: `?saverId=${this.$store.getters.getUser.id}`,
                industries: this.getRequestParamIds("industries", !isSubFilter),
                subIndustries: this.getRequestParamIds("subIndustries", isSubFilter),
                techPractices: this.getRequestParamIds("techPractices", !isSubFilter),
                subTechPractices: this.getRequestParamIds("subTechPractices", isSubFilter),
                serviceLines: this.getRequestParamIds("serviceLines", !isSubFilter),
                subServiceLines: this.getRequestParamIds("subServiceLines", isSubFilter),
                language: `&language=${this.$i18n.locale}`,
                text: store.getters.getTextForSavedProjects.trim() !== `` ? `&text=${store.getters.getTextForSavedProjects.trim()}` : ''
            }

            return `${params.user}` +
                `${this.constructRequestParam('industries', params.industries)}` +
                `${this.constructRequestParam('subIndustries', params.subIndustries)}` +
                `${this.constructRequestParam('serviceLines', params.serviceLines)}` +
                `${this.constructRequestParam('subServiceLines', params.subServiceLines)}` +
                `${this.constructRequestParam('techPractices', params.techPractices)}` +
                `${this.constructRequestParam('subTechPractices', params.subTechPractices)}` +
                `${params.text}` +
                `${params.language}` +
                `&sort=${this.sort.by}%2C${this.sort.order}` +
                `&size=${this.perPage}` +
                `&page=${this.page}`
        },
        getRequestParamIds(type, isSubFilter) {
            if (isSubFilter) {
                return this.$store.getters.getSelectedSubFiltersForSavedProjects
                    .filter(selected => selected.filterType === type).map(selected => selected.id).join(',');
            }
            return this.$store.getters.getSelectedFiltersForSavedProjects
                .filter(selected => selected.filterType === type).map(selected => selected.id).join(',');

        },
        constructRequestParam(paramName, param) {

            return param && param.length > 0 ? `&${paramName}=${param}` : '';
        },
        removeFilter(filter) {
            this.$store.dispatch("removeSelectedFilterForSavedProjects", filter);
            if (filter.subOptions) {
                filter.subOptions.forEach(subOption => this.removeSubFilter(subOption, filter))
            }
        },
        removeSubFilter(subOption, filter) {
            this.$store.dispatch("removeSelectedSubFilterForSavedProjects", {
                ...subOption,
                filterType: filter.filterType,
                mainFilterType: filter.filterType,
                mainFilterId: filter.id
            })
        },
        addFilter(filter) {
            this.$store.dispatch("addSelectedFilterForSavedProjects", filter)
            if (filter.subOptions) {
                filter.subOptions.forEach(subOption => this.addSubFilter(subOption, filter))
            }
        },
        addSubFilter(subOption, filter) {
            this.$store.dispatch("addSelectedSubFilterForSavedProjects", {
                ...subOption,
                filterType: filter.filterType,
                mainFilterType: filter.filterType,
                mainFilterId: filter.id
            })
        },
        addOrRemoveFilterSaved(filter, event) {
            event.preventDefault();

            let selectedFilters = this.$store.getters.getSelectedSubFiltersForSavedProjects;
            selectedFilters = selectedFilters.filter(selected => selected.mainFilterId === filter.id && selected.mainFilterType === filter.filterType);

            if (this.isSelected(filter.filterType, filter) && selectedFilters.length === filter.subOptions.length) {
                this.removeFilter(filter);
            } else {
                this.addFilter(filter);
                this.showSubOptions = true;
            }

            this.doSearch(event);
        },
        addOrRemoveSubFilterSaved(filter, subOption, event) {
            event.preventDefault();
            if (this.isSelected(filter.filterType, filter, subOption)) {
                this.removeSubFilter(subOption, filter);
            } else {
                this.$store.dispatch("addSelectedFilterForSavedProjects", filter)
                this.addSubFilter(subOption, filter);
            }

            this.doSearch(event);
        },
        convertToSubString(inputString) {
            const capitalizedString = inputString[0].toUpperCase() + inputString.slice(1);
            return "sub" + capitalizedString;
        },
        isSelected(filterType, filter, subOption) {
            return this.$store.getters.getSelectedSubFiltersForSavedProjects
                .find(selectedFilter => selectedFilter.filterType === subOption.filterType && selectedFilter.id === subOption.id)
        },
        preventDefault(event) {
            if (event !== null && event !== undefined) {
                event.preventDefault();
            }
        },
        capitalizeFilterType(filterType) {
            return 'sub' + filterType.charAt(0).toUpperCase() + filterType.slice(1);
        },
        addOrRemoveSubFilter(filter, subFilter, event) {
            this.preventDefault(event);

            if (!this.isLoading) {
                this.triggerSearchRequestBySubFilter(filter, subFilter);
            }
        },
        addOrRemoveFilter(filter, event) {
            this.preventDefault(event);
            if (!this.isLoading) {
                this.triggerSearchRequestByFilter(filter.filterType, filter.id);
            }
        },
        setUrlParameterByFilter(filter) {
            let mainOptionIds = this.$route.query[filter.filterType];
            let mainOptions = [];

            mainOptions = this.mainFilterActions[mainOptionIds !== undefined && this.isFilterIncludedInTheUrl(filter)
                ? 'removeMainFilterParam'
                : (mainOptionIds === undefined
                    ? 'createMainFilterParam'
                    : 'addMainFilterParam')](filter);

            this.$route.query[filter.filterType] = mainOptions.length > 0 ? mainOptions.join(',') : [];
        },
        setUrlParameterBySubFilter(filter, subFilter) {
            const subOptionType = this.capitalizeFilterType(filter.filterType);

            let subOptions = this.setSubFilterUrl(subOptionType, subFilter);
            this.setMainUrlBySubFilters(subOptions, filter);

            this.$route.query[subOptionType] = subOptions.length > 0 ? subOptions.join(',') : [];
        },
        mainFilterDoesNotHaveAddedSubFilters(subOptions, filter) {
            let filterSubOptions = !filter.subOptions
                ? this.$store.getters.getFilterOptionsByType(filter.filterType).find(filterOption => filterOption.id === filter.id).subOptions
                : filter.subOptions;

            return subOptions.every(subOption => !filterSubOptions.map(option => option.id).includes(subOption));
        },
        setSubFilterUrl(subOptionType, subFilter) {
            let subOptionIds = this.$route.query[subOptionType];

            return this.subFiltersActions[subOptionIds !== undefined && this.isSubFilterIncludedInTheUrl(subOptionType, subFilter.id)
                ? 'removeSubFilterParam'
                : (subOptionIds === undefined
                    ? 'createSubFilterParam'
                    : 'addSubFilterParam')](subOptionType, subFilter);
        },
        setMainUrlBySubFilters(subOptions, filter) {
            let mainOptionIds = this.$route.query[filter.filterType];
            let filterData = {filterType: filter.filterType, id: filter.id}

            if (subOptions.length === 0 || this.mainFilterDoesNotHaveAddedSubFilters(subOptions, filter)) {
                this.removeMainFilterParamBySubFilter(filter);
            } else if ((!mainOptionIds || mainOptionIds.length === 0) && subOptions.length > 0) {
                this.createMainFilterParamBySubFilter(filter);
            } else if (mainOptionIds.length > 0 && !this.isFilterIncludedInTheUrl(filterData)) {
                this.addMainFilterParamBySubFilter(filter, filterData)
            }
        },
        removeMainFilterParamBySubFilter(filter) {
            let mainFilterOptions = this.removeFilterFromExistingParameter(filter)
            this.$route.query[filter.filterType] = mainFilterOptions.length > 0 ? mainFilterOptions.join(',') : [];
        },
        createMainFilterParamBySubFilter(filter) {
            this.$route.query[filter.filterType] = `${filter.id}`;
        },
        addMainFilterParamBySubFilter(filter, filterData) {
            let mainFilterOptions = this.getParameterData(filterData);
            this.addFilterToExistingParameter(mainFilterOptions, filterData);
            this.$route.query[filter.filterType] = mainFilterOptions.length > 0 ? mainFilterOptions.join(',') : [];
        },
        updateUrl(url) {
            history.pushState({}, null, url);
        },
        isFilterIncludedInTheUrl(filter) {
            return this.getParameterData(filter).includes(filter.id)
        },
        isSubFilterIncludedInTheUrl(subOptionType, subFilterId) {
            return this.getSubOptionParameterData(subOptionType).includes(subFilterId);
        },
        removeSubFilterFromExistingParameter(subOptionType, subFilterId) {
            return this.getSubOptionParameterData(subOptionType).filter(id => id !== subFilterId);
        },
        removeFilterFromExistingParameter(filter) {
            return this.getParameterData(filter).filter(id => id !== filter.id);
        },
        addFilterToExistingParameter(array, filter) {
            array.push(filter.id);
        },
        addSubFilterToExistingParameter(array, subFilter) {
            array.push(subFilter.id)
        },
        getSubOptionParameterData(subFilterType) {

            return this.$route.query[subFilterType] !== null && this.$route.query[subFilterType] !== undefined
                ? this.$route.query[subFilterType].toString().split(',').filter(ids => ids.length !== 0).map(id => Number(id))
                : [];
        },
        getParameterData(filter) {

            return this.$route.query[filter.filterType] !== null && this.$route.query[filter.filterType] !== undefined
                ? this.$route.query[filter.filterType].toString().split(',').filter(a => a.length !== 0).map(id => Number(id))
                : [];
        },
        setDefaultQueryParams() {
            this.$router.replace({'query': {language: this.$i18n.locale, sort: "management_firstDatePublish,DESC"}});
        },
        fetchSearchResults(url) {
            this.$store.dispatch('showLoading')
            let uri = this.convertToBackendEntrypoint(url);
            EventSearch.$emit("toggleSubOptions");

						if (this.isLoadingNextPage) {
							SEARCH_FILTER_SERVICE.searchPageProjects()
								.then((response) => {
									this.$store.dispatch('setSearchByFiltersNextPage', {
										fieldName: 'projects',
										value: response
									})
									const now = new Date();
									this.$gtag.event("drc_searchpage_load_more", {
										event_type: "load_more",
										event_category: "drc",
										event_page: "searchpage",
										event_label: "Scrolled down on search page and loaded more projects",
										event_location: this.$route.name,
										event_path: this.$route.path,
										user_id: this.$store.getters.getUser.id,
										user_name: this.$store.getters.getUser.fullName,
										user_email: this.$store.getters.getUser.email,
										year: now.getFullYear(),
										month: now.getMonth() + 1,
										day: now.getDate(),
										time: new Date().toJSON().split('T')[1].split('.')[0]
									});
									const props = {
										action: STATISTIC_SERVICE.ACTIONS.COMMON.SEARCH_PAGE + "_FUNCTIONALITY",
										comment: JSON.stringify({previous_route: STATISTIC_SERVICE.getPreviousRoute(), parameters: decodeURIComponent(url)})
									}
									STATISTIC_SERVICE.addDrcStatistic(props);
									this.isLoadingNextPage = false;
								})
								.catch((error) => console.error(error))
								.finally(() => {
									this.$store.dispatch('hideLoading');
								});
						} else {
							Promise.all([
								SEARCH_FILTER_SERVICE.searchPageProjects()
									.then((response) => {
										this.$store.dispatch('setSearchByFilters', {
											fieldName: 'projects',
											value: response
										});
										const props = {
											action: STATISTIC_SERVICE.ACTIONS.COMMON.SEARCH_PAGE + "_FUNCTIONALITY",
											comment: JSON.stringify({parameters: decodeURIComponent(url)})
										}
										STATISTIC_SERVICE.addDrcStatistic(props);
									})
									.catch((error) => console.error(error)),
								SEARCH_FILTER_SERVICE.getProjectsCount()
									.then((response) => {
										this.$store.dispatch('setSearchByFilters', {fieldName: 'total', value: response.length});
									})
									.catch((error) => console.error(error))]
							)
								.finally(() => {
									this.$store.dispatch('hideLoading');
								});
						}
        },
        verifySaverId(url) {
            if (this.$route.query && this.$route.query['saverId'] && Number(this.$route.query['saverId']) !== this.$store.getters.getUser.id) {
                this.$route.query['saverId'] === this.$store.getters.getUser.id;
                url = url.replace(/saverId=\d+/g, `saverId=${this.$store.getters.getUser.id}`);
                this.updateUrl(url)
            }
            return url;
        },
        convertToBackendEntrypoint(url) {
            url = this.verifySaverId(url);
						const URL = process.env.VUE_APP_BACKEND_API_URL;
						const VERSION = process.env.VUE_APP_BACKEND_API_URL_VERSION;

            return url === undefined ? this.$route.fullPath.replaceAll('/projects/search', `${URL}/${VERSION}/main/projects/search`)
                : url.replaceAll('/projects/search', `${URL}/${VERSION}/main/projects/search`);
        },
        redirectToSearchPage(filterType, filterId) {
					const now = new Date();
					this.$gtag.event("use_filters", {
						event_type: "button",
						event_category: "drc",
						event_page: "home",
						event_label: "Filter clicked",
						event_location: this.$route.name,
						event_path: this.$route.path,
						user_id: this.$store.getters.getUser.id,
						user_name: this.$store.getters.getUser.fullName,
						user_email: this.$store.getters.getUser.email,
						year: now.getFullYear(),
						month: now.getMonth() + 1,
						day: now.getDate(),
						time: new Date().toJSON().split('T')[1].split('.')[0],
						filterType: filterType,
						filterId: filterId
					});

            if (this.$route.name === 'search') {
                this.updateCurrentPage(filterType, filterId);
            } else {
                this.doRedirectWithParameters(filterType, filterId);
            }
        },
        redirectToSearchPageBySubFilter(type, mainOption, subFilterType, subFilter) {
            let filter = this.$store.getters.getFilterOptionsByType(type).find(filter => filter.id === mainOption.id);
            if (this.$route.name === 'search') {
                this.updateCurrentPageBySubFilter(filter, subFilter);
            } else {
                this.doRedirectWithSubFilterParameters(filter, subFilterType, subFilter.id);
            }
        },
        doRedirectWithSubFilterParameters(industry, subFilterType, subIndustryId) {
            let url = `${this.getBaseUrl()}&${encodeURIComponent(industry.filterType)}=${encodeURIComponent(industry.id)}`
                + `&${encodeURIComponent(subFilterType)}=${encodeURIComponent(subIndustryId)}`;
            this.$router.push(url);
        },
        updateCurrentPage(filterType, filterId) {
            this.setDefaultQueryParams();
            this.triggerSearchRequestByFilter(filterType, filterId);
            this.resetTextValueAndSorting();
        },
        updateCurrentPageBySubFilter(filter, subFilter) {
            this.setDefaultQueryParams();
            this.triggerSearchRequestBySubFilter(filter, subFilter)
            this.resetTextValueAndSorting();
        },
        doRedirectWithParameters(filterType, filterId) {
            let url = `${this.getBaseUrl()}&${encodeURIComponent(filterType)}=${encodeURIComponent(filterId)}`;
            url = this.addSubOptionsToUrl(filterType, filterId, url);
            this.$router.push(url);
        },
        addSubOptionsToUrl(filterType, filterId, url) {
            let filter = this.$store.getters.getFilterOptionsByType(filterType).find(filter => filter.id === filterId);
            let subOptions = this.getSubOptionsIdsByFilter(filter);
            return `${url}&${this.capitalizeFilterType(filterType)}=${encodeURIComponent(subOptions.join(','))}`;
        },
        getSubOptionsIdsByFilter(filter) {
            return filter.subOptions && filter.subOptions.length > 0 ? filter.subOptions.map(subFilter => {
                this.setUrlParameterBySubFilter(filter, subFilter);
                return subFilter.id;
            }) : [];
        },
        triggerSearchRequestBySubFilter(filter, subFilter) {
            this.setUrlParameterBySubFilter(filter, subFilter);
            let url = this.changeUrl();
            this.fetchSearchResults(url);
        },
        triggerSearchRequestByFilter(filterType, filterId) {
            this.setUrlParameter(filterType, filterId)
            let url = this.changeUrl();
            this.fetchSearchResults(url);
        },
        changeUrl() {
            this.page = 0;
            this.$route.query.page = '0';
            let url = this.$route.path + '?' + this.buildParams();
            this.updateUrl(url);
            return url;
        },
        setUrlParameter(filterType, filterId) {
            let filter = this.$store.getters.getFilterOptionsByType(filterType).find(filter => filter.id === filterId);

            if (filter.subOptions && filter.subOptions.length > 0) {
                this.deselectAllSubOptions(filter)
                filter.subOptions.forEach(subFilter => this.setUrlParameterBySubFilter(filter, subFilter))
            } else {
                this.setUrlParameterByFilter({filterType: filterType, id: filterId});
            }
        },
        deselectAllSubOptions(filter) {
            const subOptionType = this.capitalizeFilterType(filter.filterType);
            let selectedSubOptionIds = this.getSelectedSubOptionsIds(subOptionType);
            let selectedOptions = this.getSelectedOptions(filter, selectedSubOptionIds);

            if (selectedOptions.length !== filter.subOptions.length) {
                selectedOptions.forEach(option => this.setUrlParameterBySubFilter(filter, option));
            }
        },
        getSelectedSubOptionsIds(subOptionType) {
            return this.$route.query[subOptionType] && this.$route.query[subOptionType].length >= 1
                ? this.$route.query[subOptionType].split(',').map(a => Number(a))
                : [];
        },
        getSelectedOptions(filter, selectedSubOptionIds) {
            return filter.subOptions.filter(subOption => selectedSubOptionIds.includes(subOption.id));
        },
        resetTextValueAndSorting() {
            EventSearch.$emit('cleanTextField');
            EventSearch.$emit('resetSorting');
        },
        getBaseUrl() {
            return `/projects/search?language=${this.$i18n.locale}&sort=${this.sort.by},${this.sort.order}`
                + `${this.text.trim() !== '' ? '&text=' + encodeURIComponent(this.text.trim()) : ''}&size=${this.perPage}&page=${this.page}`;
        },
        generateUriByFilter(filter) {
            if(filter.subOptions && filter.subOptions.length > 0) {
                return this.generateUriBySubFilter(filter);
            }
        },
        buildParams(isFirstLoad = false) {
            let queryObj = this.$route.query

            if (this.isSavedProjects) {
                queryObj = {...this.$route.query, saverId: this.$store.getters.getUser.id};

                this.$store.getters.getSelectedFiltersForSavedProjects.forEach(filter => {
                    if(!queryObj[filter.filterType]){
                        queryObj[filter.filterType] = filter.id;
                    }else{
                        queryObj[filter.filterType] += `,${filter.id}`;
                    }

                    const filterSubTypeName = this.capitalizeFilterType(filter.filterType);
                    filter.subOptions.forEach(subFilter => {
                        if(!queryObj[filterSubTypeName]){
                            queryObj[filterSubTypeName] = subFilter.id;
                        }else{
                            queryObj[filterSubTypeName] += `,${subFilter.id}`;
                        }
                    });
                });
            }

            let uri = Object.keys(queryObj)
                .filter(key => queryObj[key].length !== 0 && queryObj[key] !== '')
                .map(key => {
                    return (encodeURIComponent(key) + '=' + encodeURIComponent(queryObj[key]))
                })
                .join('&');

            if (isFirstLoad) {
                uri = uri.replace(`page=${queryObj.page}`, 'page=0');
            }

            return uri;
        }
    }
}
